import { ContrastModeProvider } from "@/app/providers/contrast-mode-provider"
import { ModalProvider } from "@/app/providers/modal-provider"
import { QueryProvider } from "@/app/providers/query-provider"
import { AppRouter } from "@/app/router"

export default function App() {
  return (
    <QueryProvider>
      <ContrastModeProvider>
        <ModalProvider>
          <AppRouter />
        </ModalProvider>
      </ContrastModeProvider>
    </QueryProvider>
  )
}
